/**
 * Generate a URL-friendly slug from a title
 * @param {string} title - The title to convert to a slug
 * @returns {string} - URL-friendly slug (lowercase, dashes, special chars removed)
 */
export const generateSlug = (title) => {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .trim()
    // First, normalize all whitespace (line breaks, tabs, etc.) to single spaces
    .replace(/[\r\n\t\v\f]+/g, ' ') // Replace all line breaks, tabs, and other whitespace with space
    .replace(/\s{2,}/g, ' ') // Collapse multiple spaces to single space
    // Remove special characters (but keep spaces and dashes for now)
    .replace(/[^\w\s-]/g, '')
    // Now replace spaces with dashes
    .replace(/\s/g, '-')
    // Clean up multiple dashes
    .replace(/-+/g, '-')
    // Remove leading/trailing dashes
    .replace(/^-+|-+$/g, '');
};

